export default __webpack_public_path__ + "static/springandsummer (11)-0f71862b24fda0eec1df7a17ec99fb4c.jpeg";